import { useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { useTrc20Contract } from '@/networks/tron';

const useReadTRC20Balance = (walletAddress: string | null) => {
  const [contract, setContract] = useState<string>();
  const trc20Contract = useTrc20Contract(contract);

  useEffect(() => {
    if (contract) {
      setContract(contract);
    }
  }, [walletAddress]);

  const result = useQuery({
    queryKey: ['trc20-balance', walletAddress, contract],
    queryFn: async () => {
      if (!walletAddress) {
        return Promise.resolve(0n);
      }

      const balance = await trc20Contract?.balanceOf(walletAddress).call();
      const stringBalance = balance?.toString();

      return BigInt(stringBalance || 0n);
    },
    enabled: !!walletAddress && !!trc20Contract,
    refetchInterval: 5_000,
  });

  return {
    ...result,
    contract,
    getBalance: (trc20Contract: string) => {
      if (trc20Contract) {
        setContract(trc20Contract);
      }
    },
  };
};

export default useReadTRC20Balance;
